// import styled from 'styled-components'
// import {Link} from 'react-router-dom'

// // Home container that holds the sidebar and video details
// export const HomeContainer = styled.div`
//   display: flex;
//   flex-direction: row;
//   background-color: ${props => (props.isDarkTheme ? '#181818' : '#f9f9f9')};
//   min-height: 100vh;
// `

// // Container for video details side (video player and video info)
// export const VideoDetailsSideContainer = styled.div`
//   flex-grow: 1;
//   display: flex;
//   flex-direction: column;
//   padding: 20px;
// `

// // Container for video details text and actions
// export const VideoDetailsTextContainer = styled.div`
//   padding: 20px 0;
//   border-bottom: 1px solid #d7dfe9;
// `

// // Video title text
// export const VideoDetailsText = styled.h1`
//   font-size: 20px;
//   color: ${props => (props.isDarkTheme ? '#ffffff' : '#1e293b')};
//   margin-bottom: 10px;
// `

// // Container for views and likes/dislikes
// export const ViewsDetailsContainer = styled.div`
//   display: flex;
//   justify-content: space-between;
//   margin-bottom: 10px;
// `

// // Text for views count and publish date
// export const ViewsText = styled.p`
//   font-size: 16px;
//   color: ${props => (props.color ? props.color : '#64748b')};
// `

// // Container for like, dislike, and save buttons
// export const LikesContainer = styled.div`
//   display: flex;
//   align-items: center;
// `

// // Icon button styles
// export const IconContainer = styled.button`
//   display: flex;
//   align-items: center;
//   background: none;
//   border: none;
//   color: ${props => props.color};
//   cursor: pointer;
//   margin-right: 15px;
// `

// // Horizontal line
// export const HorizontalLine = styled.hr`
//   border: 1px solid #d7dfe9;
//   margin: 20px 0;
// `

// // Channel logo styles
// export const ChannelLogo = styled.img`
//   width: 40px;
//   height: 40px;
//   border-radius: 50%;
// `

// // Channel info container
// export const ChannelContainer = styled.div`
//   display: flex;
//   align-items: center;
// `

// // Container for the channel logo
// export const LogoContainer = styled.div`
//   margin-right: 10px;
// `

// // Container for channel details
// export const ChannelDetailsContainer = styled.div`
//   margin-left: 10px;
// `

// // Loader container for loading state
// export const ProductsLoaderContainer = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   min-height: 80vh;
//   background-color: ${props => (props.isDarkTheme ? '#181818' : '#ffffff')};
// `

// // NotFound container for error view
// export const NotFoundContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   min-height: 80vh;
//   background-color: ${props => (props.isDarkTheme ? '#181818' : '#f9f9f9')};
// `

// // Image for error view
// export const Image = styled.img`
//   width: 300px;
// `

// // Heading for error view
// export const Heading = styled.h1`
//   color: ${props => (props.isDarkTheme ? '#ffffff' : '#1e293b')};
// `

// // Description text for error view
// export const Desc = styled.p`
//   color: ${props => (props.isDarkTheme ? '#ffffff' : '#1e293b')};
// `

// // Link styles
// export const NavLink = styled(Link)`
//   text-decoration: none;
// `

// // Retry button styles
// export const Retry = styled.button`
//   background-color: #4f46e5;
//   color: #ffffff;
//   border: none;
//   padding: 10px 20px;
//   cursor: pointer;
//   border-radius: 5px;
//   margin-top: 10px;
// `


import styled from 'styled-components';
import { Link } from 'react-router-dom';

// Home container that holds the sidebar and video details
export const HomeContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${props => (props.isDarkTheme ? '#181818' : '#f9f9f9')};
  min-height: 100vh;
`;

// Container for video details side (video player and video info)
export const VideoDetailsSideContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

// Container for video details text and actions
export const VideoDetailsTextContainer = styled.div`
  padding: 20px 0;
  border-bottom: 1px solid #d7dfe9;
`;

// Video title text
export const VideoDetailsText = styled.h1`
  font-size: 20px;
  color: ${props => (props.isDarkTheme ? '#ffffff' : '#1e293b')};
  margin-bottom: 10px;
`;

// Container for views and likes/dislikes
export const ViewsDetailsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

// Text for views count and publish date
export const ViewsText = styled.p`
  font-size: 16px;
  color: ${props => (props.isDarkTheme ? '#ffffff' : '#1e293b')};
  color: ${props => (props.color ? props.color : '#64748b')};
`;

// Container for like, dislike, and save buttons
export const LikesContainer = styled.div`
  display: flex;
  align-items: center;
`;

// Icon button styles
export const IconContainer = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  color: ${props => props.color};
  cursor: pointer;
  margin-right: 15px;
`;

// Horizontal line
export const HorizontalLine = styled.hr`
  border: 1px solid #d7dfe9;
  margin: 20px 0;
`;

// Channel logo styles
export const ChannelLogo = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
`;

// Channel info container
export const ChannelContainer = styled.div`
  display: flex;
  align-items: center;
`;

// Container for the channel logo
export const LogoContainer = styled.div`
  margin-right: 10px;
`;

// Container for channel details
export const ChannelDetailsContainer = styled.div`
  margin-left: 10px;
`;

// Loader container for loading state
export const ProductsLoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
  background-color: ${props => (props.isDarkTheme ? '#181818' : '#ffffff')};
`;

// NotFound container for error view
export const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  background-color: ${props => (props.isDarkTheme ? '#181818' : '#f9f9f9')};
`;

// Image for error view
export const Image = styled.img`
  width: 300px;
`;

// Heading for error view
export const Heading = styled.h1`
  color: ${props => (props.isDarkTheme ? '#ffffff' : '#1e293b')};
`;

// Description text for error view
export const Desc = styled.p`
  color: ${props => (props.isDarkTheme ? '#ffffff' : '#1e293b')};
`;

// Link styles
export const NavLink = styled(Link)`
  text-decoration: none;
`;

// Retry button styles
export const Retry = styled.button`
  background-color: #4f46e5;
  color: #ffffff;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 5px; 
  margin-top: 10px;
`;